<template>
  <div class="role-page-container">
    <div class="header">
      <div class="title">角色列表</div>
      <el-button v-permission="'add'" class="operate-btn" @click="handleNewRole" type="primary">新增</el-button>
    </div>
    <!-- <div class="page-operate-block">
      <div>
        <el-button v-permission="'update'" class="operate-btn" :disabled="options.selection.length != 1" @click="handleEditRow">编辑</el-button>
        <el-button v-permission="'delete'" class="operate-btn" :disabled="options.selection.length === 0" @click="handleDeleteRow">删除</el-button>
      </div>
    </div> -->
    <!-- <el-button v-permission="'export'" class="operate-btn" @click="handleRoleImport">导出</el-button> -->

    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      >
        <el-table-column prop="name" label="角色名称" min-width="250px" show-overflow-tooltip>
          <template #default="scope">
            <a @click.prevent="handleDetail(scope.row)" style="cursor: pointer;">{{ scope.row.name }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="角色描述" min-width="500px" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="操作" min-width="250px" show-overflow-tooltip>
          <template #default="scope">
            <a @click.prevent="handleEditRow(scope.row)" style="cursor: pointer; margin-right: 16px;">编辑</a>
            <a @click.prevent="handleDeleteRow(scope.row)" style="cursor: pointer; color: red;">删除</a>
          </template>
        </el-table-column>
      </r-table>
    </div>

    <RModal :title="modalTitle" v-model="addModal" top="5vh" width="800px" @change="addModal = false" @close="addModal = false">
      <template #content>
        <RoleForm
          ref="role-form"
          v-if="addModal"
          :role-id="curRoleInfo.id"
          :oper-type="operType"
          :role-info="curRoleInfo"
          @reload="reloadTableData"
          @cancel="addModal = false"
        ></RoleForm>
      </template>
    </RModal>
  </div>
</template>
<script>
import mixin from '@/components/common/tableMixin'
import RModal from '@/components/common/RModal'
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import RoleForm from './roleForm'

export default {
  name: 'rolesIndex',
  mixins: [mixin, tableMix],
  components: { RModal, RTable, RoleForm },
  data() {
    return {
      perms: [],
      tableVarity: 'system-roles-table',
      addModal: false,
      modalTitle: '详情',
      curRoleInfo: 0,
      operType: 'newRole',

      options: {
        // multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        // mutiSelect: true,
        // selection: [],
      },
      filters: {
        search: { keyword: '' },
      },

      tableData: [],
      error: '',
    }
  },
  created() {
    this.perms = 'perms' in localStorage && localStorage.perms !== '' ? JSON.parse(localStorage.perms) : []
    let params = {
      current: 1,
      size: this.pagination.pageSize,
    }
    //判断是否需要获取数据
    this._fetch(params)
  },
  mounted() {},
  methods: {
    // 是否显示这个按钮
    isShowBtn(perm) {
      let url = window.location.pathname.substr(5)
      let len = this.perms.length
      let pid = ''
      for (let i = 0; i < len; i++) {
        if (this.perms[i].url == url) {
          pid = this.perms[i].id
        }
      }
      for (let i = 0; i < len; i++) {
        if (this.perms[i].pid == pid && this.perms[i].perm == perm) {
          return true
        }
      }

      return false
    },
    _fetch(params) {
      this._requestData()

      let url = 'ROLE.POST_LIST'
      this.fetchData({ url, method: 'post', params }).then((res) => {
        this.tableData = res.list || []
        this.pagination.total = res && res.total
      }).catch((err) => {
        this.error = err
      }).finally(() => {
        this._receiveData()
      })
    },
    _reloadData() {
      let params = {
        current: this.pagination.pageIndex,
        size: this.pagination.pageSize,
      }
      //强制请求数据
      this._fetch(params)
    },
    // 分页
    handlePageChange(val, ops) {
      this.pagination.pageIndex = val
      this.pagination.pageSize = ops
      this._reloadData()
    },
    handleSearch() {
      this.pagination.pageIndex = 1
      this._reloadData()
    },
    // 处理新增操作
    handleNewRole() {
      this.curRoleInfo = {}
      this.operType = 'newRole'
      this.modalTitle = '新增'
      this.addModal = true
    },
    // 处理详情操作
    handleDetail(row) {
      this.curRoleInfo = row
      this.operType = 'showRole'
      this.modalTitle = '详情'
      this.addModal = true
    },
    // 处理编辑操作
    handleEditRow(row) {
      this.handleEdit(row)
    },
    // 打开编辑弹框
    handleEdit(row) {
      this.curRoleInfo = row
      this.operType = 'editRole'
      this.modalTitle = '编辑'
      this.addModal = true
    },
    // 处理删除操作
    handleDeleteRow(row) {
      this.$confirm(
        // '确定删除当前选中的（' + this.options.selection.length + '条记录）信息吗？',
        `确定删除角色「${row.name}」信息吗？`,
        { type: 'warning' }
      ).then(() => {
        this.handleDelete([row])
      }).catch(() => false)
    },
    // 删除数据
    handleDelete(rows) {
      let url = 'ROLE.POST_DELETE'
      let params = rows.map((item) => item.id)
      this.fetchData({ url, method: 'post', params, headers: { 'Content-Type': 'application/json' } }).then((res) => {
        if (!res.success) {
          return this.$message.error(res.info || '删除失败！')
        }
        this.$message.success('删除成功！')
        if (rows.length === this.tableData.length) { // 删除了当前页全部数据
          if (this.pagination.pageIndex > 1) { // 页码大于1
            if (this.pagination.total <= this.pagination.pageIndex * this.pagination.pageSize) {
              this.pagination.pageIndex--
            }
          }
        }
        this._reloadData()
      }).catch((err) => {
        this.$message.error(err)
      })
      $('body').trigger('click')
    },
    handleRoleImport() {
      this.roleToExcel = true
      this._reloadData()
    },
    // 刷新表格数据
    reloadTableData() {
      this.addModal = false
      this._reloadData()
    },
  },
}
</script>
<style lang="less" scoped>
.role-page-container {
  padding-top: 5px;
  background-color: white;
  border-radius: 16px;
}
.theme-darkblue .m-r-xs:last-of-type {
  margin-right: 0px !important;
}
.header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 25px 0;
  .title{
    font-size: 24px;
  }
}
</style>
<style lang="less">
.el-popover__title {
  font-size: 14px;
}
.splitline {
  color: @font-darkblue-color-theme;
}
</style>
